import {Injectable} from "@angular/core";
import {TradeCrudComponent} from "../../../crystal-clear/support/trade-crud/trade-crud.component";
import {FieldRecord} from "../../../model/api/field-record";
import {Trade} from "../../../model/clearing/trade";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {StringUtils} from "../../../utils/stringUtils";

@Injectable({
  providedIn: 'root'
})
export class SupportTradeDataLoadingService {

  openCloses: FieldRecord<any>[];
  sides: FieldRecord<any>[];
  tradeStates: FieldRecord<any>[];
  callPuts: FieldRecord<any>[];
  agressors: FieldRecord<any>[];

  loadData(component: TradeCrudComponent) {
    this.openCloses = Object.keys(AccountDefinition.OpenClose).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.sides = Object.keys(Trade.Side).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.tradeStates = Object.keys(Trade.TradeState).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.callPuts = Object.keys(Trade.CallPut).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.agressors = Object.keys(Trade.AggressorInd).map(key => new FieldRecord(key, StringUtils.humanize(key)));

    component.tracker.incrementTotal();
    component.tracker.incrementDone();
  }

}
